import GlobalSettings from './GlobalSettings.js';
import React, { useContext, useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import '../styles/Head.css';
import PageHeader from './PageHeader.js';
import PageFooter from './PageFooter.js';
import PageInvalid from './PageInvalid.js';
import { GlobalStateContext } from './GlobalStateContext.js';

const Survey = () => {
    const {
        surveyCode,
        questionset_id,
        setQuestionsetId,
        participation,
        setParticipation,
        token,
        setToken,
        answers,
        surveyName,
        setSurveyName,
        surveyTitle,
        setSurveyTitle,
        openquestion_id,
        setOpenquestionId,
        closedQuestion_id,
        setClosedQuestionId,
        valid,
        setValid, 
        surveyId,
        setSurveyId, 
        participationCode, 
        surveyMode
    } = useContext(GlobalStateContext);
    //console.log("SUcd" ,surveyCode);
    //console.log("tokiToke", participationCode);
    const [state, setState] = useState({
        title: [],
        token,
        topic: [],
        bodyText: [],
        buttonText: [],
        numberOfQuestions: 0,
        introTextClosedQuestions: '',
        question: [],
        completeSet: [],
        tokenValid: "",
        surveyName,
        surveyTitle,
        surveyId, 
        surveyCompleted: false
    });
    
    const navigate = useNavigate();
    const languageId = GlobalSettings.languageId;
    if(GlobalSettings.debugMode==='on') {
        console.log("surId", surveyId);
        console.log("Mode", surveyMode);
        console.log("PCode", participationCode);
    }
    useEffect(() => {
        const fetchData = async () => {
            try {
                if(GlobalSettings.debugMode==='on') 
                    console.log("Survey", localStorage);
                // questionset_id
                if (surveyId) {
                    const questionSetResult = await fetch('/api/questionSet/' + surveyId);
                    const questionSetData = await questionSetResult.json();
                    setQuestionsetId(questionSetData?.questionset_id);
                } else {
                    setQuestionsetId(0);
                }


                // SurveyName
                const surveyNameResult = await fetch('/api/surveyNameSurvey/'  + surveyId);
                const surveyNameData = await surveyNameResult.json();
                setSurveyName(surveyNameData[0].Survey_Name);
                //console.log("SurName", surveyName);

                // check Survey-completion
                // survey already completed?
                // if preview or debug, there might be no participationCode, so check with survey-id

                if(participationCode){
                    const surveyCompletedResult = await fetch('/api/surveyDone/' + participationCode);

                    const surveyCompletedData = await surveyCompletedResult.json();
                    
                    setState(prevState => ({
                        ...prevState,
                        surveyCompleted: surveyCompletedData
                    }))
                }
                else {
                    setState(prevState => ({
                        ...prevState,
                        surveyCompleted: 0
                    }))
                }

                // Title
                const titleResult = await fetch('/api/text/' + languageId);
                const titleData = await titleResult.json();
                setSurveyTitle(titleData);
                
                // introClosedQuestions
                const introTextResult = await fetch(`/api/introClosedQuestions/${questionset_id}/${languageId}`);
                const introTextData = await introTextResult.json();
               // console.log("itd" ,introTextData);
                setState(prevState => ({ ...prevState, introTextClosedQuestions: introTextData }));

                // AnzahlFragen
                if (surveyId) {
                    const questionsResult = await fetch('/api/numberofquestions/' + surveyId);
                    const questionsData = await questionsResult.json();
                    setState(prevState => ({ ...prevState, numberOfQuestions: questionsData.length }));
                } else {
                    setState(prevState => ({ ...prevState, numberOfQuestions: 0 }));
                    setQuestionsetId(0);
                }

                // Buttontext
                const buttonTextResult = await fetch('/api/button');
                const buttonTextData = await buttonTextResult.json();
                setState(prevState => ({ ...prevState, buttonText: buttonTextData }));
                
            } catch (error) {
                console.log(error);
            }
        };

        fetchData();
    }, [surveyCode, surveyName, surveyTitle, questionset_id, languageId]);

    const questionCount = state.numberOfQuestions || 0;
    const introText = state.introTextClosedQuestions.replace("<cntQuestions>", questionCount);

    if ((!token || state.surveyCompleted) && (!surveyMode)) {
        return (
            <div>
                <PageHeader />
                <PageInvalid />
                <PageFooter />
            </div>
        );
    }

    return (
        <div>
            <div>
                <PageHeader headerText={surveyTitle} surveyName={surveyName} mode={surveyMode} />
            </div>
            <div className="questionBody">
                <div className="bubbleInactive"></div>
                <div className="bubbleActive">
                    <div className="bubbleTextContent">
                        {introText?.split('\n').map((line, index) => (
                            <React.Fragment key={index}>
                                {line}
                                <br />
                            </React.Fragment>
                        ))}
                    </div>
                    <div className="bubbleFooter">
                        <div className="bubbleStart">
                            <Link to={`/questions`}>
                                <button className="btnBubble">{state.buttonText[0]?.text}</button>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="bubbleInactive"></div>
            </div>
            <PageFooter progress={100} />
        </div>
    );
};

export default Survey;
